<!-- =========================================================================================
  File Name: Categories.vue
  Description: Categories' list
  ----------------------------------------------------------------------------------------
  Item Name: deltaPOS - Categories list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>

  <div>
    <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-plus" class="add-button" :to="{name: 'category', params: { id: 0 }}"/>

    <div class="vx-card p-6">
      <ejs-grid
        ref="grid"
        :dataSource="data"
        locale='es-GT'
        :toolbar='toolbarOptions'
        :allowPaging="true"
        :pageSettings='pageSettings'
        :allowSorting='true'
        :sortSettings='sortOptions'
        :allowExcelExport='true'
        :toolbarClick='toolbarClick'
        v-if="loaded"
      >
        <e-columns>
          <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
          <e-column field='code' headerText='Código' width="150" :template="cTemplate" displayValue="code" routeName="category" urlBase="/catalogs/products/category/"/>
          <e-column field="name" headerText="Nombre" :template="cTemplate" displayValue="name" routeName="category" urlBase="/catalogs/products/category/"/>
          <e-column field="order" headerText="Orden" textAlign='Right' width="100"/>
          <e-column field="availablePOS" headerText="Disponible PdV" width="150" :template='checkBoxTemplate' checked="availablePOS"/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';

  var deltaPOS_config = require('@/deltaPOS.config.js')


  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport} from '@syncfusion/ej2-vue-grids';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import CellRendererLink from '@/views/infra/cell-renderer/CRLinkS';
  import CheckBoxCellTemplate from '@/views/infra/cell-renderer/CheckBoxCellTemplate';

  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'grid': {
        'EmptyRecord': 'No se encontraron categorías de productos',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        pageSettings: {pageSize: 15},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'name', direction: 'Ascending'}, {field: 'code', direction: 'Ascending'}]},
        statusId: null,
        loaded: false,
        data: [],
        cTemplate: function () {
          return {template: CellRendererLink, urlBase: '/catalogs/products/category/'};
        },
        checkBoxTemplate: function () {
          return {template: CheckBoxCellTemplate};
        }
      }
    },
    components: {
      CellRendererLink,
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport]
    },
    methods: {
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          let excelExportProperties = {
            fileName: "ListadoCategorías.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      getList() {
        this.$vs.loading({
          text: 'Cargando listado de categorías de productos',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/products/categories/list', this.$store.state.AppActiveUser).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              self.data = response.data.data
            }
          }
          this.$vs.loading.close();
          self.loaded = true;
        }).catch(error => {
          self.loaded = true;
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.response) {
            errorMessage = error.response.data.ErrorMessage
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar listado de categorías',
            text: errorMessage,
            color: 'danger'
          });
        })
      },
      edit(id) {
        this.$router.push(`/catalogs/products/category/${id}`).catch(() => {
        });
      }
    },
    mounted() {
      this.getList();
    }
  }

</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

  .add-button {
    position: fixed;
    bottom: 5%;
    right: 29px;
    z-index: 51000;
    box-shadow: 0 1px 20px 1px rgb(251, 67, 79);
  }
</style>
